import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../service/Api";

export const createEvent = createAsyncThunk("createEvent", async (data) => {
    const response = await API.post('event/create', data);
    return response.data;
});

export const getEvents = createAsyncThunk("getEvents", async ({ page, limit, search, startOfMonth, endOfMonth }) => {
    const response = await API.get('event/list', {
        params: { page, limit, search, startOfMonth, endOfMonth }
    });
    return response.data;
});

export const getEventDetail = createAsyncThunk("getEventDetail", async ({ id }) => {
    const response = await API.get('event/details', {
        params: { id }
    });
    return response.data;
});
export const getEventReqSongs = createAsyncThunk("getEventReqSongs", async ({ limit, page, clientId }) => {
    const response = await API.get('event/requested-song', {
        params: { limit, page, clientId }
    });
    return response.data;
});
export const getEventSongs = createAsyncThunk("getEventSongs", async ({ limit, page, eventId }) => {
    const response = await API.get('event/song', {
        params: { limit, page, eventId }
    });
    return response.data;
});

export const getClientsDetails = createAsyncThunk("getClientsDetails", async ({ userId }) => {
    const response = await API.get('userProfile', {
        params: { userId }
    });
    return response.data;
});
export const getCategories = createAsyncThunk("getCategories", async () => {
    const data = await API.get("profile/categories");
    return { data };
});
export const updateFile = createAsyncThunk("updateFile", async (payload) => {
    const data = await API.post("chatbot/upload", payload);
    return { data };
});

export const addChatBot = createAsyncThunk("addChatBot", async (data) => {
    const response = await API.post('chatbot', data);
    return response.data;
});
export const exportBotChat = createAsyncThunk("exportBotChat", async ({ chatbotId, start_date, end_date }) => {
    const response = await API.get('admin/getConversations', {
        params: { chatbotId, start_date, end_date }
    });
    return response.data;
});
export const addFaq = createAsyncThunk("addFaq", async (data) => {
    const response = await API.post('faq', data);
    return response.data;
});
export const addPrompt = createAsyncThunk("addPrompt", async (data) => {
    const response = await API.post('prompt', data);
    return response.data;
});
export const addSource = createAsyncThunk("addPrompt", async (data) => {
    const response = await API.put('admin/updatePrompt', data);
    return response.data;
});
export const getFaqById = createAsyncThunk("getFaqById", async ({ id }) => {
    const response = await API.get(`faq/${id}`);
    return response.data;
});
export const getPromptById = createAsyncThunk("getPromptById", async ({ id }) => {
    const response = await API.get(`prompt/${id}`);
    return response.data;
});
export const getSource = createAsyncThunk("getSource", async () => {
    const response = await API.get(`admin/getPrompt`);
    return response.data;
});
export const addAdmin = createAsyncThunk("addAdmin", async (data) => {
    const response = await API.post('admin/create-admin', data);
    return response.data;
});
export const editAdmin = createAsyncThunk("editAdmin", async (data) => {
    const response = await API.put('admin/updateAdmin', data);
    return response.data;
});

export const getChatBot = createAsyncThunk("getChatBot", async ({ id }) => {
    const response = await API.get(`chatbot/chatDetails/${id}`);
    return response.data;
});
export const getAdmin = createAsyncThunk("getAdmin", async ({ id }) => {
    const response = await API.get(`admin/getAdminById?adminId=${id}`);
    return response.data;
});

export const downNewUserCSV = createAsyncThunk("downNewUserCSV", async (payload) => {
    const response = await API.post('client/new-user', payload);
    return response.data;
});
export const downClientsCSV = createAsyncThunk("downClientsCSV", async (payload) => {
    const response = await API.post('client/new-user', payload);
    return response.data;
});
